import script from "./ArchivedTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivedTask.vue?vue&type=script&setup=true&lang=js"

import "./ArchivedTask.vue?vue&type=style&index=0&id=2f5f39c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5f39c4"]])

export default __exports__